module.exports = __webpack_public_path__ + "img/bomen snoeien Jan.5ecb8611.jpg";